import {makeAutoObservable} from "mobx";
import {navigationStore} from "./NavigationStore";
import {fmsBarcodeScanStore} from "./fms";
import {vhsBarcodeScanStore} from "./vhs";

class KeyboardEventStore {
    get buffer(): string[] {
        return this._buffer;
    }

    private set buffer(value: string[]) {
        this._buffer = value;
    }

    private _buffer: string[] = []

    constructor() {
        makeAutoObservable(this)
    }

    onKeyDown(event: KeyboardEvent) {
        const target = event.target as HTMLElement

        if (
            event.ctrlKey ||
            event.altKey ||
            event.metaKey
        ) {
            return
        }

        if ('Enter' === event.key) {
            this.write(this.buffer.join(''))
            this.buffer = []
            return
        }
        const isInput = target.tagName === 'INPUT'
        const isTextarea = target.tagName === 'TEXTAREA'
        const isContentEditable = target.isContentEditable
        const isShiftKey = event.key === 'Shift'

        if (isInput || isTextarea || isContentEditable || isShiftKey) {
            return
        }

        this.buffer = [...this.buffer, event.key]
    }

    write(val: string) {
        if (navigationStore.activePath.startsWith("/fms")) {
            fmsBarcodeScanStore.notify(val).finally()
            return
        }
        vhsBarcodeScanStore.notify(val).finally()
    }
}

const keyboardEventStore = new KeyboardEventStore()

export {
    keyboardEventStore
}
